import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../constant/api';
import axios from 'axios';
import { Link } from 'react-router-dom';

function SponsoredViewAll() {
    const [Sponsored, setSponsored] = useState([
        {
            id: 1,
            banner: "/images/Promotion/Sponser/s1.jpg",
            title: "Summer Sale",
            start_date: "2025-06-01",
            end_date: "2025-06-30",
            path: "/sponsored/all"
        },
    ]);
    const [error, setError] = useState('');

    // // Fetch Data Function
    // const fetchData = async (url, setter) => {
    //     try {
    //         const response = await axios.get(url);
    //         const data = response.data.Data || response.data.data;
    //         console.log(url, data);
    //         if (data) {
    //             setter(data);
    //             setError(''); // Clear previous errors if any
    //         }
    //     } catch (error) {
    //         console.error(`Error fetching data from ${url}:`, error);
    //         setError(
    //             error.response?.data?.message || 'Failed to fetch sponsored products.'
    //         );
    //     }
    // };

    // // Handle Image Loading Errors
    // const handleImageError = (e) => {
    //     e.target.src = '/images/default-product.png';
    // };

    // // useEffect for Initial Data Fetch
    // useEffect(() => {
    //     fetchData(`${BASE_URL}/products/sponsored/`, setSponsored);
    // }, []);

    return (
        <div className="carousel-container my-2">
            {/* Header */}
            <div className="flex justify-between items-center px-5 py-3">
                <h2 className="text-xl font-semibold text-gray-800 px-4 py-2">Sponsored</h2>
            </div>

            {/* Error Message */}
            {error && <p className="text-red-500 text-center my-2">{error}</p>}

            {/* Sponsored Items */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-5">
                {Sponsored.length > 0 ? (
                    Sponsored.map((sponsor) => (
                        <div key={sponsor.id} className="rounded-lg overflow-hidden">
                            {/* <Link to={`/sponsored/${sponsor.id}/`} >
                                <div className='h-[130px] md:h-[258px] rounded-sm'>
                                <img
                                    src={
                                        sponsor.banner
                                            ? sponsor.banner.startsWith(BASE_URL)
                                                ? sponsor.banner
                                                : `${BASE_URL}${sponsor.banner}`
                                            : '/images/default-product.png'
                                    }
                                    alt={sponsor.name || 'Product'}
                                    className="w-full h-full object-fill"
                                    onError={handleImageError}
                                />
                                </div>
                            </Link> */}
                            <Link to={`${sponsor.path}`} >
                                <div className='h-[130px] md:h-[258px] rounded-sm'>
                                    <img
                                        src={
                                            sponsor.banner
                                        }
                                        alt={sponsor.name || 'Product'}
                                        className="w-full h-full object-fill"
                                        // onError={handleImageError}
                                    />
                                </div>
                            </Link>
                        </div>
                    ))
                ) : (
                    // Fallback for Empty Sponsored List
                    <p className="text-gray-500 text-center w-full col-span-full">
                        No sponsored products available at the moment.
                    </p>
                )}
            </div>
        </div>
    );
}

export default SponsoredViewAll;
